import { Alert, Box, Text } from '@factorialco/deprecated-design-system'
import { NewCardLegalEntityFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import AccountOnboardingLink from 'modules/banking/components/AccountOnboarding/Link'

interface Props {
  legalEntity: NewCardLegalEntityFragment
  hasEnabledAccount: boolean
  cardsAvailable: boolean
}
export const AccountAlert = ({ hasEnabledAccount, cardsAvailable, legalEntity }: Props) => {
  if (hasEnabledAccount) return null

  const descriptionOptions = {
    legal_entity_name: (
      <Text inline color="grey1000" size="200" weight="medium">
        {legalEntity.legalName}
      </Text>
    ),
  }

  return (
    <Alert color="warning">
      <Box gap="s16" paddingY="s8">
        <Box gap="s8">
          <Text.Normal weight="medium" color="grey1000">
            {cardsAvailable
              ? i18n.t('expenses_v2.alerts.accounts.not_completed.title', {
                  legal_entity_name: legalEntity.legalName,
                })
              : i18n.t('expenses_v2.alerts.accounts.not_available.title')}{' '}
          </Text.Normal>

          <Text.Normal color="grey1000" size="200">
            {cardsAvailable
              ? i18n.tView(
                  'expenses_v2.alerts.accounts.not_completed.description',
                  descriptionOptions
                )
              : i18n.tView(
                  'expenses_v2.alerts.accounts.not_available.description',
                  descriptionOptions
                )}
          </Text.Normal>
        </Box>

        {cardsAvailable && (
          <AccountOnboardingLink
            label={i18n.t('expenses_v2.alerts.accounts.not_completed.cta')}
            source="expenses"
            legalEntityId={legalEntity.id}
          />
        )}
      </Box>
    </Alert>
  )
}
